import { Plane } from "lucide-react";

/* PJ1 Brandmark — sharp serif "PJ1" wordmark + small marque.
   Used in the dashboard sidebar AND on the widget. Cabinet Grotesk only. */
export function Brandmark({ size = "md", showSub = true, dataTestid }) {
  const big = size === "lg";
  return (
    <div
      data-testid={dataTestid || "brandmark"}
      className="flex items-start gap-2 select-none min-w-0"
    >
      <div
        className={`flex items-center justify-center flex-shrink-0 ${
          big ? "h-9 w-9" : "h-7 w-7"
        }`}
        style={{ borderRadius: 1, background: "linear-gradient(90deg, rgb(169,130,28), rgb(158,92,44))", color: "rgb(252,249,243)" }}
      >
        <Plane className={big ? "h-4 w-4" : "h-3.5 w-3.5"} strokeWidth={2.4} />
      </div>
      <div className="leading-tight min-w-0">
        <div
          className={`font-display truncate ${big ? "text-lg" : "text-base"}`}
          style={{ letterSpacing: "-0.04em", fontWeight: 700 }}
          title="Private Jet One"
        >
          Private Jet One
        </div>
        {showSub && (
          <div className="pj-label" style={{ fontSize: "9px" }}>
            PJ1 OS · v0.1
          </div>
        )}
      </div>
    </div>
  );
}

export default Brandmark;
